import { render, staticRenderFns } from "./carouselPic.vue?vue&type=template&id=63423709&scoped=true"
import script from "./carouselPic.vue?vue&type=script&lang=js"
export * from "./carouselPic.vue?vue&type=script&lang=js"
import style0 from "./carouselPic.vue?vue&type=style&index=0&id=63423709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63423709",
  null
  
)

export default component.exports